module.exports = __webpack_public_path__ + "img/consent_renewed_successfull.e9ec158f.svg";